

















import {Component, Mixins} from 'vue-property-decorator';
import ActionModal from '@/layouts/back-office/elements/actions/ActionModal.vue';
import ActionMixin from '@/layouts/back-office/elements/actions/ActionMixin';
import AuctionTypeSelect from '@/components/auction/input/AuctionTypeSelect.vue';
import {
  AuctionList, ApproveAuctionGrantVariables,
} from '@/types/auction';
import Input from '@/components/elements/input/Input.vue';
import InputTextarea from '@/layouts/back-office/elements/input/InputTextarea.vue';

@Component({
  components: {InputTextarea, Input, AuctionTypeSelect, ActionModal},
})
export default class GrantAuctionAction extends Mixins(ActionMixin) {
  protected auction: AuctionList | null = null;
  protected remark: string | null = null;

  public open(auction: AuctionList) {
    this.auction = auction;

    const modal: ActionModal = this.$refs.actionModal as ActionModal;

    modal.open();
  }

  protected get approveAuctionGrantVariable(): ApproveAuctionGrantVariables | null {
    if (!this.auction) {
      return null;
    }

    return {
      id: this.auction.id,
      remark: this.remark,
    };
  }
}
